import { type FC } from "react";
import { Button } from "../../components/ui/button";
import { Activity, Footprints, Heart, Moon, Zap } from "lucide-react";
import { useNavigate } from "react-router-dom";
import fitbitAuthService from "../../services/FitbitAuthService";


import { notify } from "@/components/common/Notification";


const FitbitConnectionPage: FC = () => {
  const navigate = useNavigate();



  const handleConnectNow = async () => {
    await fitbitAuthService.loginRedirect((err: string) => {
      notify.error(err);
    });
  };

  const benefits = [
    { icon: Footprints, text: "Track daily steps & activity" },
    { icon: Heart, text: "Monitor heart rate & calories" },
    { icon: Moon, text: "Analyze sleep quality" },
    { icon: Zap, text: "Optimize workout performance" },
  ];

  return (
    <div className="h-screen w-screen overflow-hidden bg-background">
      <div className="mx-auto flex h-full w-full max-w-md flex-col">
        {/* Content */}
        <div className="flex-1 overflow-y-auto px-4 py-4 sm:px-6 sm:py-8">
          <div className="flex flex-col items-center space-y-4 text-center sm:space-y-6">
            {/* Activity Icon */}
            <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-gradient-to-br from-blue-500 to-orange-400 sm:h-20 sm:w-20">
              <Activity
                className="h-8 w-8 text-white sm:h-10 sm:w-10"
                strokeWidth={2}
              />
            </div>

            {/* Heading */}
            <h1 className="text-2xl font-bold text-foreground sm:text-3xl">
              Connect Your Fitbit
            </h1>

            {/* Description */}
            <p className="max-w-sm text-xs text-muted-foreground sm:text-sm">
              We'll use it to track steps, heart rate, sleep, and exercise to
              give you better Bite Balance predictions.
            </p>

            {/* Benefits List */}
            <div className="w-full space-y-3 pt-4">
              {benefits.map((benefit, idx) => (
                <div
                  key={idx}
                  className="flex items-center gap-3 rounded-lg border border-border bg-card p-3"
                >
                  <benefit.icon className="h-5 w-5 flex-shrink-0 text-primary" />
                  <span className="text-sm text-foreground">
                    {benefit.text}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Footer Buttons */}
        <div className="pb-safe space-y-2 p-4 sm:space-y-3">
          <Button
            type="button"
            onClick={handleConnectNow}
            className="h-12 w-full rounded-2xl bg-gradient-primary text-base shadow-lg hover:opacity-90 sm:h-14 sm:text-lg"
          >
            Yes, Connect Now
          </Button>
          <button
            onClick={() => navigate("/glucera/homepage")}
            className="w-full py-2 text-center text-xs text-foreground transition-colors hover:text-primary sm:text-sm"
          >
            Not Now
          </button>

        </div>
      </div>
    </div>
  );
};

export default FitbitConnectionPage;
